module.exports = __webpack_public_path__ + "cad7328691be7b2e7cfb9058a53a2442.svg";